module.exports = __webpack_public_path__ + "img/追踪反馈数量.f2767a5e.svg";